module.exports = __webpack_public_path__ + "static/media/icCoinJoin.9b5b6284.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Ecosystem/images/icCoinJoin.svg
// module id = 1011
// module chunks = 0